<template>
    <qrcode-vue :value="value"
                :size="size"
                :level="level"
                :background="background"
                :foreground="foreground"
                :render-as="renderAs"
                :class-name="className" />
</template>

<script>
import QrcodeVue from 'qrcode.vue'
export default {
  name: "QrCodeGenerator",
  components: {
    QrcodeVue
  },
  props: {
    value: {
      type: String,
      required: true,
    },
    size: {
      type: Number,
      required: true,
      default: 100
    },
    // qrcode Error correction level (one of 'L', 'M', 'Q', 'H').
    // https://en.wikipedia.org/wiki/QR_code#Error_correction
    level: {
      type: String,
      required: false,
      default: 'H'
    },
    background: {
      type: String,
      required: false,
      default: '#ffffff'
    },
    foreground: {
      type: String,
      required: false,
      default: '#000000'
    },
    renderAs: {
      type: String,
      required: false,
      default: 'canvas' // or svo
    },
    className: {
      type: String,
      required: false,
      default: ''
    },
  }
}
</script>

<style scoped>

</style>